import React from 'react';
import cx from 'classnames';
import { ELSIconV2 } from 'components/common';
import { getFirstColumnMinWidth, getRowMinWidth } from './ResponsiveTableHelper';
export var FIRST_COLUMN_INDEX = 0;
export var renderBodyRow = function (_a) {
    var _b;
    var record = _a.record, columns = _a.columns, hasScrollLeft = _a.hasScrollLeft, rowIndex = _a.rowIndex, handleExpandRow = _a.handleExpandRow, isRowExpanded = _a.isRowExpanded, recordIdField = _a.recordIdField, handleExpandRowByRowState = _a.handleExpandRowByRowState, checkExpandStateById = _a.checkExpandStateById, expandedRowState = _a.expandedRowState, tableId = _a.tableId, _rowMinWidth = _a.rowMinWidth, _bodyRowGTC = _a.bodyRowGTC, _c = _a.rowExpandable, rowExpandable = _c === void 0 ? false : _c, _d = _a.isSingleExpand, isSingleExpand = _d === void 0 ? false : _d, _e = _a.expandedRows, expandedRows = _e === void 0 ? [] : _e;
    var rowId = ((_b = record[recordIdField]) !== null && _b !== void 0 ? _b : rowIndex);
    var shouldExpandArrowRender = function (columnIndex) { return rowExpandable && columnIndex === FIRST_COLUMN_INDEX; };
    var isFinalRowExpand = false;
    if (!isSingleExpand && checkExpandStateById && typeof checkExpandStateById === 'function') {
        isFinalRowExpand = checkExpandStateById(rowId, expandedRowState);
    }
    else if (isRowExpanded && typeof isRowExpanded === 'function') {
        isFinalRowExpand = isRowExpanded(rowId);
    }
    var onExpandClick = function () {
        if (handleExpandRowByRowState && typeof handleExpandRowByRowState === 'function') {
            handleExpandRowByRowState(rowId, !isFinalRowExpand, expandedRowState);
        }
        else if (rowExpandable) {
            handleExpandRow(rowId);
        }
    };
    var renderCell = function (column, idx) {
        var shouldExpandRow = (column || {}).shouldExpandRow;
        var shouldExpand = shouldExpandRow && typeof shouldExpandRow === 'function' ? shouldExpandRow(record) : shouldExpandArrowRender(idx);
        if (shouldExpand) {
            var isExpanded = isFinalRowExpand || isRowExpanded(rowId) || (expandedRows || []).includes(rowId);
            var expandLabel = isExpanded ? 'Collapse row' : 'Expand row';
            return (<button type="button" aria-expanded={isExpanded} aria-label={expandLabel} className={cx('c-responsive-table-body-cell--expandable', { 'c-responsive-table-body-cell--expandable-expanded': isExpanded })} onClick={onExpandClick}>
          <ELSIconV2 sprite={isExpanded ? 'ChevronUp' : 'ChevronDown'} size="xs" aria-hidden className="u-els-color-secondary u-els-margin-right-1o2"/>
          {column.customRender ? column.customRender(record, column) : record[column.field]}
        </button>);
        }
        return column.customRender ? column.customRender(record, column) : record[column.field];
    };
    return (<tr className={cx('c-responsive-table-body-row', { 'c-responsive-table-body-row--expanded': isFinalRowExpand })}>
      {columns.map(function (column, idx) {
            var alignClass = column.align ? "u-els-text-align-".concat(column.align) : '';
            return (<td key={"body-".concat(rowExpandable ? 'cell-expandable' : 'cell', "-").concat(rowId, "-").concat(column.field.toString())} headers={"".concat(tableId !== null && tableId !== void 0 ? tableId : 'tbl', "-col-").concat(String(column.field))} className={cx('c-els-table__cell c-responsive-table-body-cell', {
                    'c-responsive-table-body-cell--sticky': !idx,
                    'c-responsive-table-body-cell--right-shadow': !idx && hasScrollLeft
                }, alignClass, column.headerCssModifier, column.cssModifier)}>
            {renderCell(column, idx)}
          </td>);
        })}
    </tr>);
};
export var wrapRowInTable = function (columns, row) {
    var totalMinWidth = getRowMinWidth(columns);
    return (<table className="c-responsive-table-row-wrapper">
      <colgroup>
        {columns.map(function (col) {
            var _a;
            return (<col key={String((_a = col.field) !== null && _a !== void 0 ? _a : col.cssModifier)} style={{ width: "".concat((getFirstColumnMinWidth(col) / totalMinWidth) * 100, "%") }}/>);
        })}
      </colgroup>
      <tbody>{row}</tbody>
    </table>);
};
